// Auto-generated translation for no.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:16:52.918595+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "For hesteeiere",
    title: "Alt for hesten din. I én app.",
    subtitle: "Administrer helse, trening, planlegging og fagfolk fra én oversiktlig mappe.",
    primaryCTA: {
      label: "Start gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Hesteprofil — vekt, vaksinasjon, EquiCoach, fôring og trening på én skjerm",
      caption: "Hesten din, fullstendig oversikt.",
    },
    problem: "Du holder sannsynligvis avtaler, bilder, trening, fôring og helse spredt rundt — i WhatsApp-grupper, esker og separate apper. Det gjør at du mister oversikten.",
    solution: "EquiSight gjør hesten din til én komplett digital mappe som følger deg overalt.",
    benefits: [
      "Én komplett hesteprofil per hest",
      "Helse, hovsmed, tannlege og fysioterapeut på ett sted",
      "Kalender med smarte påminnelser",
      "Bilder, notater og historikk uten grense",
      "Sikkerhetskopiering av alle data med Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 hest · alltid gratis",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Flere hester + sikkerhetskopiering",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar til å starte?",
      title: "Begynn i dag med din første hest.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Flere hester. Bedre oversikt. Større trygghet.",
    subtitle: "Oppgrader til Premium og administrer alle hestene dine uten begrensninger — med full EquiCoach-intelligens.",
    primaryCTA: {
      label: "Start 14 dager gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Alle priser",
      href: "/#pricing",
    },
    audience: "For eiere, sportssporere og hesteholdere med flere hester.",
    features: [
      "Legg til ubegrenset antall hester",
      "Fullstendig historikk per hest",
      "Sikkerhetskopiering av data",
      "Utvidede EquiCoach-innsikter",
      "Smarte varsler og planlegging",
      "Helse og trening fullstendig koblet sammen",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mindre enn €0,17 per dag",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Oppgrader til Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "For manegeryttere",
    title: "Bli bedre, selv uten egen hest.",
    subtitle: "Følg timene dine, treninger og utvikling i EquiSight — for mindre enn en kopp kaffe per måned for mamma eller pappa. Eller en god iskrem med krem.",
    primaryCTA: {
      label: "Start med Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Hvordan fungerer det?",
      href: "#features",
    },
    problem: "Som manegerytter har du ofte ikke din egen hest, men du ønsker likevel å vokse og ha oversikt over timene dine, målene dine og hestene du rir på.",
    solution: "Manegefunksjonalitet er inkludert som standard i Premium — følg din egen utvikling og se de tilknyttede manegehestene i skrivebeskyttet modus.",
    features: [
      "Hold styr på treninger",
      "Sett mål",
      "Følg fremgang",
      "Se manegehester med navn og bilde",
      "Ingen tilgang til privat helsedata",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per måned · manegefunksjonalitet inkludert",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bli medlem",
      title: "Start som manegerytter.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "For ridehaller og staller",
    title: "Gjør ridehallen din digitalt tilgjengelig for enhver rytter.",
    subtitle: "Gi ryttere tilknytning til hester, timer og fremgang — uten å dele sensitiv stalldata.",
    primaryCTA: {
      label: "Be om tilgang",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se moduler",
      href: "#features",
    },
    audience: "EquiSight hjelper ridehaller og staller med å holde ryttere engasjert lenger og skille seg ut digitalt.",
    features: [
      "Gjøre ridehallhester synlige for ryttere",
      "Navn og bilde per hest",
      "Koble ryttere til hester",
      "Skrivebeskyttet tilgang for personvernsensitiv data",
      "Time- og treningshistorikk samlet på ett sted",
      "Brukeradministrasjon med roller",
    ],
    benefits: [
      "Sterkere tilknytning til ryttere",
      "Mer profesjonelt inntrykk",
      "Ekstra digital tjeneste for medlemmer",
      "Ny inntektsstrøm via appbruk",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per måned · ridehall-funksjonalitet inkludert for ryttere",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktiver Ridehall-modulen.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Avlsmodul",
    title: "Full kontroll over syklus, drektighet og følutvikling.",
    subtitle: "Den komplette avlsmodulen for hoppeiere og avlere — fra dekning til føl, i én tidslinje.",
    primaryCTA: {
      label: "Aktiver Avlsmodul",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se funksjoner",
      href: "#features",
    },
    audience: "For avlere, hoppeiere og staller som håndterer flere hopper.",
    features: [
      "Syklussporing",
      "Registrere brunsttegn",
      "Loggføre inseminasjonsdata",
      "Nedtelling til ekko",
      "Planlegge drektighetssjekker",
      "Stamtavle og avstamning",
      "Følutvikling",
      "Oversikt over alle drektige hopper",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per måned · Avlsmodul inkludert i Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Kom i gang i dag",
      title: "Start med avlsforvaltning.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Hovslager-modul",
    title: "Jobb smartere som hovslager. Dokumentér alt på en profesjonell måte.",
    subtitle: "Kalender, bilder, kommentarer og behandlingshistorikk i én modul — mindre misforståelser, sterkere dokumentasjon.",
    primaryCTA: {
      label: "Start som hovslager",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional-pakken",
      href: "/professional",
    },
    audience: "For hovslagere som ønsker bedre oversikt, dokumentasjon og kundekommunikasjon.",
    features: [
      "Egen kalender",
      "Avtaler per kunde",
      "Se hesteprofiler",
      "Legg til bilder før og etter",
      "Notér behandling",
      "Registrér råd og kommentarer",
      "ETA-varsling til kunde: \"Hovslageren er på vei\"",
    ],
    benefits: [
      "Mer profesjonell arbeidsflyt",
      "Færre misforståelser",
      "Bedre journaloppbygging",
      "Sterkere ved ansvarsspørsmål",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · Hovslager-modul inkludert i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktiver Hovslager-modulen.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Tannlegemodул",
    title: "Et komplett tannhelsearkiv per hest.",
    subtitle: "Registrer funn, behandlinger og oppfølging direkte i EquiSight.",
    primaryCTA: {
      label: "Start som hestetannlege",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional-pakken",
      href: "/professional",
    },
    audience: "Hestetannleger, veterinærer og praksiser som ønsker å jobbe strukturert.",
    features: [
      "Registrer tannkontroll",
      "Funn per behandling",
      "Legg til bilder",
      "Rapport til eier",
      "Oppfølgingsråd",
      "Historikk per hest",
      "Planlegg ny avtale",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · Tannlegemodul inkludert i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktiver tannlegemodulen.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fysio / Osteo modul",
    title: "Følg kropp, bevegelse og rehabilitering på en profesjonell måte.",
    subtitle: "For fysioterapeuter og osteopater som ønsker å følge opp hester på en strukturert måte.",
    primaryCTA: {
      label: "Start som fysio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional Bundle",
      href: "/professional",
    },
    features: [
      "Inntak per hest",
      "Registrer kroppsfunn",
      "Legg til bilder og videoer",
      "Lage behandlingsrapport",
      "Dele øvelser og oppfølging",
      "Følge rehabiliteringsforløp",
      "Historikk per hest",
    ],
    benefits: [
      "Bedre innsikt over tid",
      "Profesjonell rapportering",
      "Tydelig kommunikasjon med eier, trener og rytter",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · Fysio / Osteo modul inkludert i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktiver Fysio / Osteo modul.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trener-modul",
    title: "Tren ryttere med data, mål og fremgang.",
    subtitle: "Gjør treningen målbar og veiledningen mer profesjonell — for én eller flere ryttere.",
    primaryCTA: {
      label: "Start som trener",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Pro-pakken",
      href: "/#pricing",
    },
    audience: "For instruktører, trenere og coacher med flere ryttere eller hester.",
    features: [
      "Koble til ryttere",
      "Følge hester",
      "Sette treningsmål",
      "Gi tilbakemelding",
      "Analysere konkurranseresultater",
      "Se fremgang per kombinasjon",
      "Bruke protokollanalyser for treningsfokus",
    ],
    benefits: [
      "Bedre veiledning",
      "Mer struktur",
      "Mer profesjonell kommunikasjon",
      "Sterkere kundeforhold",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per måned · Trener-modul inkludert i Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktiver Trener-modulen.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Konkurranseanalyse",
    title: "Fra protokoll til prestasjonsforbedring.",
    subtitle: "Last opp konkurranseprotokollen din og oppdag hvor du mister poeng — ikke bare se scoren din, men forstå hvordan du blir bedre.",
    primaryCTA: {
      label: "Analyser din første protokoll",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Premium",
      href: "/premium",
    },
    features: [
      "Last opp protokollfoto",
      "Behandle for- og bakside",
      "Gjenkjenne klasse, øvingsnummer og dommer",
      "Analysere poeng per deloppgave",
      "Oppsummere kommentarer",
      "Vise sterke og svake sider",
      "Trender per hest-rytter-kombinasjon",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per måned · konkurranseanalyse inkludert fra Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Start med konkurranseanalyse.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional-pakke",
    title: "For fagfolk rundt hesten.",
    subtitle: "Hovsmed, tannlege, fysioterapeut, osteopat eller trener: samarbeid i én digital hestemappe.",
    primaryCTA: {
      label: "Start som fagperson",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se individuelle moduler",
      href: "#features",
    },
    audience: "Professional-pakken kombinerer alle fagmoduler i ett abonnement.",
    features: [
      "Hovsmed-modul",
      "Tannlege-modul",
      "Fysioterapi / Osteopati-modul",
      "Kalender og kundehåndtering",
      "Hesteprofiler og rapporter",
      "Behandlingshistorikk og journaloppbygging",
      "Kommunikasjon med eier",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · alle fagmoduler inkludert",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Velg Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Nødnumre for hest",
    title: "Alltid riktig hjelp innen rekkevidde.",
    subtitle: "I en nødsituasjon teller hvert sekund. Med EquiSight har du alle viktige kontaktopplysninger for hesten din alltid klare — ett trykk og du ringer.",
    primaryCTA: {
      label: "Sett opp dine nødkontakter nå",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Start gratis med EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Nødkontakter — ring direkte, send WhatsApp eller naviger til veterinær, klinikk og hovsmed",
      caption: "Ett trykk. Ingen panikk-leting.",
      embeddedFrame: true,
    },
    problem: "Hesten din har det vondt — kolikk, skade, panikk. Og så begynner letingen. Hvem ringer du? Har du riktig nummer? Er dette nødnummeret? Verdifull tid går tapt.",
    solution: "Med EquiSight har du alt rett ved hånden. Ingen leting. Ingen tvil. Ett trykk og du har kontakt.",
    scenario: {
      title: "Tenk deg — hesten din viser tegn på kolikk.",
      steps: [
        "Du åpner EquiSight",
        "Trykker på \"Veterinær\"",
        "Ringer direkte",
      ],
      tagline: "Ingen stress. Ingen leting. Bare handling.",
    },
    features: [
      "Alle nødnumre på ett sted",
      "Ring med ett trykk fra appen",
      "Send WhatsApp med ett trykk",
      "Naviger direkte til adressen",
      "Egen kontaktliste per hest",
      "Veterinær, klinikk, hovsmed, tannlege, fysioterapeut",
      "Adresse og veibeskrivelse alltid tilgjengelig",
      "Marker favorittNumre med en stjerne",
      "Nødnumre (112, 144) alltid øverst",
    ],
    benefits: [
      "Ro og kontroll i en nødsituasjon",
      "Alle på stallen har de samme numrene klare",
      "Ingen glemte visittkort mer",
      "Reager sekunder raskere ved nødsituasjoner",
    ],
    audience: "For hesteeiere, ryttere, trenere og staller — alle som har ansvar for en hest.",
    showcase: {
      eyebrow: "Forhåndsinnstilt for deg",
      title: "13 kategorier med kontakter — klare til å fylles ut.",
      description: "Fra veterinær og nødklinikk til salmakker, instruktør og beitemarksforvalter. EquiSight kjenner din verden og setter opp de riktige kontaktfeltene for deg på forhånd. Trykk, fyll inn, ferdig.",
      bullets: [
        "Nød og helse — veterinær, nød, klinikk, forgiftningstelefon",
        "Daglig stell — hovsmed, tannlege, fysio, instruktør",
        "Stall og beite — stallforvalter, beitemarksforvalter, pensjonsstall",
        "Fôr og utstyr — høy, kraftfôr, strøleverandører",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Skjerm for administrasjon av nødkontakter — alle foreslåtte kontakter per kategori",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Sjekkliste nødnumre for hest",
      items: [
        "Veterinær",
        "Nødklinikk (24/7)",
        "Dyreambulanse · 144",
        "Hovsmed",
        "Reservekontaktperson",
        "Generelt nødnummer · 112",
      ],
      cta: {
        label: "Åpne i EquiSight og fyll inn direkte",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Nødnumre",
          price: "Gratis",
          note: "Alltid gratis · for alle, i alle abonnementer",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Sørg for at du er forberedt",
      title: "Før du trenger det.",
      href: "/#waitlist",
    },
    microcopy: [
      "Ingen forpliktelser",
      "Klar på under 2 minutter",
      "Alltid justerbar",
    ],
  },
};

export default LANDINGS;
